import * as React from "react";
import { DynamicForm } from "../../util/DynamicForm";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import { apiPost } from "../../util/axiosUtil";
import API_URL from "../../config/apiConfig";
import { z } from "zod";
import MutationHandler from "../../util/MutationHandler"; // Import reusable handler

const Refund = ({ onCancel, data, onSuccess }) => {
  const getOptions = () => {
    return Array.from({ length: data.refundableMonths }, (_, i) => {
      const value = Number(i + 1); // force numeric value
      return {
        id: value,
        name: `${value} Month${value > 1 ? "s" : ""}`,
        value: value,
      };
    });
  };

  const formFields = {
    durationInMonths: {
      label: "Duration in Months",
      type: "select",
      options: getOptions(),
      valueType: "number",
      defaultValue: null,
      required: true,
      validation: z.preprocess((val) => {
        const num = Number(val);
        return isNaN(num) ? undefined : num;
      }, z.number().min(1, { message: "Months must be at least 1" })),
    },
    reason: {
      label: "Reason",
      type: "textarea",
      valueType: "text",
      defaultValue: "",
      required: false,
      validation: z.string().min(0, "Please provide a reason"),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) =>
        apiPost(`${API_URL}/api/refunds/${data.id}`, formData)
      }
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => {
        return (
          <RefundForm
            formFields={formFields}
            onSubmit={(value) => mutation.mutate(value)}
            isLoading={mutation.isPending}
            onCancel={onCancel}
          />
        );
      }}
    </MutationHandler>
  );
};

const RefundForm = ({ formFields, onSubmit, isLoading, onCancel }) => {
  const form = useGeneratedForm(formFields, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formFields}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Create Refund"}
    />
  );
};

export default React.memo(Refund);
